export default __webpack_public_path__ + "images/title-slide-background.0cd6c955e9fb958a1ce0f498b939b00b.png";